import { Sparkles } from "lucide-react";

interface EventTypeBadgeProps {
  type?: string;
}

export function EventTypeBadge({ type }: EventTypeBadgeProps) {
  if (!type) return null;
  
  const styles: Record<string, string> = {
    wedding: 'bg-rose-50 text-rose-700 border-rose-200',
    corporate: 'bg-blue-50 text-blue-700 border-blue-200',
    birthday: 'bg-amber-50 text-amber-700 border-amber-200',
    anniversary: 'bg-purple-50 text-purple-700 border-purple-200',
    engagement: 'bg-pink-50 text-pink-700 border-pink-200',
    reception: 'bg-indigo-50 text-indigo-700 border-indigo-200',
    conference: 'bg-cyan-50 text-cyan-700 border-cyan-200',
    party: 'bg-violet-50 text-violet-700 border-violet-200',
  };

  const normalizedType = type.toLowerCase().replace(/\s+/g, '_');
  const style = styles[normalizedType] || 'bg-stone-50 text-stone-700 border-stone-200';

  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border ${style}`}>
      <Sparkles className="w-3 h-3 mr-1" />
      {type}
    </span>
  );
}
